import React, { useState, useEffect, useContext } from "react";
import { DeviceContext } from "context/deviceProvider";
import { END_POINT } from "context/endPoint";
import { Divider, Header, Icon, Segment } from "semantic-ui-react";
import "scss/components/maintenance/maintenanceAdd.scss";

export default function MaintenanceAdd(props) {
  const [detail, setDetail] = useState(props?.order);
  const devices = useContext(DeviceContext);

  useEffect(() => {
    setDetail(props?.order);
    console.log(props?.order);
  });

  const onGetMonth = (month) => {
    const monthNames = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ];
    return monthNames[parseInt(month) - 1];
  };

  const displayImages = () => {
    return (
      <>
        <div className="image">
          <Divider horizontal>
            <Header as="h4">
              <Icon name="images" />
              รูปภาพ
            </Header>
          </Divider>
          <div className="image-add">
            {detail?.images?.add?.length > 0 &&
              detail?.images?.add?.map((image, idx) => (
                <div key={idx} className="fadein">
                  <img
                    key={idx}
                    alt="add-maintenance"
                    src={`${END_POINT}/get/image?name=${image.path}`}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      </>
    );
  };

  const mapPartCode = (code) => {
    let part = devices?.partsList?.filter((parts) => parts.code === code);

    if (part?.length > 0) {
      return part[0].name_th;
    }
    return;
  };

  const detailDate = (content1, content2) => {
    return (
      <table className="detail">
        <tbody>
          <tr>
            <td>{content1}</td>
            <td>{content2 || "-"}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <div className="maintenanceAdd">
      <div className="maintenanceAdd-topic">
        <Divider horizontal>
          <Header as="h3">
            <Icon name="warning circle" />
            การแจ้งซ่อม
          </Header>
        </Divider>
      </div>
      <Segment>
        <table className="add">
          <tbody>
            <tr>
              <td>{detailDate("Running Number", detail?.documentNo)}</td>
              <td>
                {detailDate(
                  "วันที่และเวลาแจ้งซ่อม",
                  detail?.createAt
                    ? `${detail?.createAt.substring(8, 10)} 
                            ${onGetMonth(detail?.createAt.substring(5, 7))} 
                            ${parseInt(detail?.createAt.substring(0, 4)) + 543} 
                            ${detail?.createAt.substring(10, 19)}`
                    : null
                )}
              </td>
            </tr>
            <tr>
              <td>
                {detailDate(
                  "ชื่อผู้ใช้งาน",
                  detail?.fullName || detail?.userId
                )}
              </td>
              <td>{detailDate("หมายเลขเครื่องจักร", detail?.clpSerial)}</td>
            </tr>
            <tr>
              <td>{detailDate("เบอร์โทรศัพท์", detail?.phoneNo)}</td>
              <td>{detailDate("ที่อยู่", detail?.address)}</td>
            </tr>
            <tr>
              <td>
                {detailDate(
                  "วิธีการติดต่อ",
                  detail?.contactChoice === "on_site"
                    ? "แก้ไขหน้างาน"
                    : "โทรศัพท์"
                )}
              </td>
              <td>{detailDate("ปัญหาแจ้งซ่อม", detail?.topic)}</td>
            </tr>
            <tr>
              <td>
                {detailDate(
                  "สถานะอะไหล่",
                  detail?.inWarranty === 1
                    ? "อยู่ในการรับประกัน"
                    : "ไม่อยู่ในการรับประกัน"
                )}
              </td>
              <td>
                {detailDate("แจ้งซ่อมอะไหล่", mapPartCode(detail?.partCode))}
              </td>
            </tr>
            <tr>
              <td>
                {detailDate(
                  `วันที่เริ่มใช้งาน`,
                  detail?.periodActiveRange
                  ? `${detail?.periodActiveRange.substring(8, 10)} 
                       ${onGetMonth(detail?.periodActiveRange.substring(5, 7))} 
                       ${parseInt(detail?.periodActiveRange.substring(0, 4)) + 543}`
                  : null                 
                )}
              </td>
              <td>
                {detailDate(
                  "วันที่พบปัญหา",
                  detail?.problemDetectionDate
                    ? `${detail?.problemDetectionDate.substring(8, 10)} 
                            ${onGetMonth(detail?.problemDetectionDate.substring(5, 7))} 
                            ${parseInt(detail?.problemDetectionDate.substring(0, 4)) + 543}`
                    : null
                )}
              </td>
            </tr>
            <tr>
              <td>
                {detailDate(
                  "ปริมาณการใช้งาน",
                  `${detail?.amountOfUse || ""} ${
                    detail?.amountOfUseUnit || ""
                  }`
                )}
              </td>
              <td>{detailDate("หมายเหตุ", detail?.note)}</td>
            </tr>
          </tbody>
        </table>

        {displayImages()}
      </Segment>
    </div>
  );
}
